'use strict';

import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import MenuList from '@material-ui/core/MenuList';
import SidebarMenuItem from 'Components/Navigation/SidebarMenuItem';
import sidebar_config from 'Components/Navigation/sidebar_config';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const {
  app
} = window;
export default class Sidebar extends Component {
  state = function () {
    const state = {
      collapses: JSON.parse(window.localStorage.getItem('Sidebar.collapses') || '{}'),
      roles: app.state.session?.user?.roles || []
    };
    state.links = getLinks(state.collapses);
    return state;
  }();
  pathname = window.location.pathname;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session?.fetched) {
      component.handleSessionChange({
        source: 'DidMount'
      });
      component.setState({
        links: getLinks(state.collapses)
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.pathname !== window.location.pathname) {
      component.pathname = window.location.pathname;
      return component.setState({
        links: getLinks(state.collapses)
      });
    }
    const roles = app.state.session?.user?.roles || [];
    if (_isEqual(roles, state.roles) === false) {
      return component.setState({
        links: getLinks(state.collapses)
      });
    }
  }
  handleSessionChange = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let collapses = JSON.parse(window.localStorage.getItem('Sidebar.collapses') || '{}');
    component.setState({
      collapses: collapses,
      roles: app.state.session?.user?.roles || []
    });
  };
  handleDashBoardMenuClick = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      accomodation_open: !state.accomodation_open
    });
  };
  onClick = (e, link) => {
    let component = this,
      props = this.props,
      state = this.state;
    Object.keys(state.collapses).filter(url => url !== link.url && state.collapses[url]).forEach(url => state.collapses[url] = false);
    state.collapses[link.url] = !state.collapses[link.url];
    window.localStorage.setItem('Sidebar.collapses', JSON.stringify(state.collapses));
    component.setState({
      collapses: state.collapses,
      links: getLinks(state.collapses)
    });
  };
  render = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const etablishment = app.state.session?.user?._etablishment || {};
    const items = Object.keys(state.links).map(function (name) {
      const link = state.links[name];
      let output = /*#__PURE__*/React.createElement(SidebarMenuItem, _extends({}, link, {
        key: link.url || link.action,
        onClick: (e, data) => component.onClick(e, {
          ...data
        })
      }));
      return output;
    });
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'o-sidebar' + (props.open ? ' o-sidebar--open' : '')
    }, /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      className: "o-sidebar__logo-link"
    }, /*#__PURE__*/React.createElement(Logo, {
      className: "o-sidebar__logo",
      type: "white"
    })), (state.roles || []).includes('hotelier') ? /*#__PURE__*/React.createElement("h2", {
      className: "sidebar-title"
    }, etablishment?.name) : (state.roles || []).includes('company') ? /*#__PURE__*/React.createElement("h2", {
      className: "sidebar-title"
    }, app.state?.session?.user?.name) : (state.roles || []).includes('marketing') ? /*#__PURE__*/React.createElement("h2", {
      className: "sidebar-title"
    }, "Marketing") : /*#__PURE__*/React.createElement("h2", {
      className: "sidebar-title"
    }, "Admin"), items));
    return output;
  };
}
function getLinks(collapses = {}) {
  const roles = app.state.session?.user?.roles || [];
  const etablishment = app.state.session?.user?._etablishment || {};
  let links = {};
  if (roles.includes('admin')) {
    if (isTrue(app.state.session?.user?.super_admin) && etablishment) {
      links = _cloneDeep(sidebar_config.super_admin_links);
      links.super_admin.sub_items.etablishment_form.url = URL('AdminEtablishmentsDashboard') + '/' + etablishment.id;
    } else {
      links = _cloneDeep(sidebar_config.admin_links);
    }
  } else if (roles.includes('hotelier')) {
    links = _cloneDeep(sidebar_config.hotelier_links);
    links.etablishments.url = URL('AdminEtablishmentsDashboard') + '/' + etablishment.id;
  } else if (roles.includes('marketing')) {
    links = _cloneDeep(sidebar_config.marketing_links);
  } else if (roles.includes('company')) {
    links = _cloneDeep(sidebar_config.company_links);
  }
  links = setLinksData(links, collapses);
  return links;
}
function setLinksData(links, collapses = {}) {
  const pathname = document.location.pathname.endsWith('/') ? document.location.pathname.slice(0, -1) : document.location.pathname;
  const top_level_names = Object.keys(links);
  top_level_names.forEach(function (name, i) {
    setSelected(links[name], 0);

    // another link before is already marked as selected
    if (top_level_names.slice(0, i).some(name => links[name].selected)) {
      links[name].selected = false;
    }
    const sub_selected = Object.keys(links[name].sub_items || {}).some(sub_name => links[name].sub_items[sub_name].selected === true);
    if (sub_selected) {
      links[name].selected = true;
    }
  });
  return links;
  function setSelected(link, level) {
    const url = link.url || URL(link.action);
    if (pathname === url) {
      link.selected = true;
    } else {
      link.selected = pathname.startsWith(url) && pathname.slice(0, url.length + 1).endsWith('/');
    }
    link.level = level;
    if (Object.keys(link.sub_items || {}).length > 0) {
      link.open = Boolean(collapses[url]);
    }
    Object.keys(link.sub_items || {}).forEach(function (name) {
      setSelected(link.sub_items[name], level + 1);
    });
  }
}
